import { useQuery } from '@tanstack/react-query';
import { getObservationSettings } from './requests';
import { ObservationSettingsTarget } from './types';

export const observationSettingsKey = ['env-scales', 'assessments', 'settings'];

export function useObservationSettings(target?: ObservationSettingsTarget) {
  return useQuery({
    queryKey: [...observationSettingsKey, target],
    queryFn: () =>
      getObservationSettings(target!).then(res => res.data.settings),
    enabled: Boolean(target),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: 15 * 60 * 1000
  });
}
